<!-- 隐私政策 -->
<template>
<div class="wraper">
  <div style="white-space:pre-wrap">
		<div class="history_info">
			<div class="btext">最近更新日期：2022年【04】月【28】日</div>
			<div class="btext">最新生效日期：2022年【04】月【28】日</div>
			<div class="btext">发布日期：2022年【04】月【28】日</div>
			<div @click="checkHistory" class="check_history_btn">查看历史版本</div>
		</div>
		<div class="text_info">
			<div class="inline normal">
				本隐私政策（以下简称“本政策”）
			</div>
			<div class="inline big">
				适用于由深圳市丰驰顺行信息技术有限公司及其关联方（以下简称“顺陆”或“我们”）通过官方网站、顺陆APP、微信公众号、顺陆开放平台、小程序及相应的网页版软件，以及经顺陆服务提供者授权的第三方产品上所集成的部分顺陆功能等向客户（以下简称“您”）提供的顺陆产品及服务。<br>
				我们将向您介绍顺陆对个人信息保护的原则、对您的个人信息的收集和处理方式、通用的保护措施和机制，并向您展示顺陆个人信息保护的基本标准和系统化建设全貌。<br>
				定义与解释<br>
				顺陆服务运营与开发公司名称：深圳市丰驰顺行信息技术有限公司。<br>
				顺陆小程序使用方：深圳市丰驰顺行信息技术有限公司及其现在已设立的及后续新设的关联公司、子公司、分公司。其中目前已设立的关联公司有浙江丰驰网络科技有限公司、天津市元合利科技有限公司、江西顺丰智达网络科技有限公司。<br>
				深圳市丰驰顺行信息技术有限公司注册地址：深圳市南山区粤海街道滨海社区高新南十道81号、83号、85号软件产业基地1栋B1202；法人代表：卢致椿 常用办公地址：广东省深圳市南山区高新南区科苑南路3176号彩讯科创中心17楼。<br>
				用户信息保护工作机构：深圳丰驰数据与IT建设部及顺丰科技技术集团信息安全与内控部，以下简称“顺陆”。<br>
				顺陆服务：指顺陆服务提供者基于顺陆官网、顺陆开放平台、顺陆客户端、小程序及相应的网页版软件，向您提供的有关公路运输需求服务。<br>
				顺陆客户端：指您自行通过合法且经顺陆服务提供者授权的正规软件下载渠道或平台，下载并安装到您的终端设备上且与该设备相适配的“顺陆”App软件，主要版本包括iOS、Android应用版本。<br>
			</div>
			<div class="inline normal">
				我们努力以简明、清晰、易于理解的方式展现本政策。顺陆深知个人信息对您的重要性，并会尽全力保护您的个人信息安全。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，顺陆承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。<br>
				在使用我们的产品前，请仔细阅读本政策，以便您更好地了解我们的产品及其提供的各项服务，并作出适当的选择。
			</div>
			<div class="inline big">
				除非法律、行政法规另有规定外，针对我们如何处理您的个人信息，您享有知情权和决定权，有权限制或者拒绝我们或其他方对您的个人信息进行处理；同时，您有权要求我们对我们向您提供的个人信息处理规则进行解释说明。
			</div>
			<div class="inline normal">
				为了使您充分知悉和理解我们对您的个人信息的处理方式、处理范围和处理后果等规则，并作为您行使相关权利的基础，我们特别撰写了“。
			</div>
			<div class="inline big">
				1.我们处理您的个人信息的基本规则”，
			</div>
			<div class="inline normal">
				以落实我们应向您履行的法定告知义务。基于此，我们强烈建议您首先仔细阅读该部分说明，并在充分理解本政策内容的基础上做出相应的授权同意。<br>
			</div>
			<div class="inline normal">
				如果您有任何疑问、意见或建议，请拨打客服联系方式4001116663或通过本政策“9. 如何联系我们”中的联系方式进一步与我们联系。<br>
			</div>
			<div class="inline normal">
				本政策将帮助您了解以下内容：<br>
			</div>
			<div class="inline big">
				1. 我们处理您的个人信息的基本规则<br>
				2. 我们如何收集和使用您的个人信息<br>
				3. 我们如何保护您的个人信息<br>
				4. 您的权利<br>
				5. 我们如何处理儿童的个人信息<br>
				6. 我们对去世用户的个人信息保护<br>
				7. 您的个人信息如何在全球范围内转移<br>
				8. 我们如何更新隐私政策及法律适用<br>
				9. 如何联系我们<br>
				1. 我们处理您的个人信息的基本规则<br>
			</div>
			<div class="inline normal">
				本政策中的重要定义以《个人信息保护法》、《个人信息安全规范》（GB/T35273-2020）中的相关定义为基准，我们针对我们的实际情况进行了相关补充，若有不一致之处应以《个人信息保护法》、《个人信息安全规范》的规定为准。提请您额外注意的是，本部分说明的核心目的在于指导您充分知悉和理解我们对您的个人信息的处理方式、处理范围和处理后果等规则，以落实我们应向您履行的法定告知义务。基于此，我们强烈建议您仔细阅读本部分说明，并在充分理解说明内容的基础上做出授权同意或明示同意。<br>
			</div>
			<div class="inline big">
				1.1 个人信息：
			</div>
			<div class="inline normal">
				指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息。如个人电话号码、个人信息主体帐号、IP地址、唯一设备识别码等。
			</div>
			<div class="inline big">
				敏感个人信息：
			</div>
			<div class="inline normal">
				是指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁的未成年人的个人信息。本政策中，若个人信息为敏感个人信息的，我们将以
			</div>
			<div class="inline big">
				字体加粗的形式
			</div>
			<div class="inline normal">
				提示您注意并获取您的单独同意，您应额外关注此类信息的列举。
			</div>
			<div class="inline big">
				您可以通过“2.1个人信息的收集和使用”所列的表格中的说明了解我们会在何种场景及基于何种目的处理的个人信息类型，
			</div>
			<div class="inline normal">
				就我们为您提供的服务而言，我们处理的您的个人信息的范围如下所示：
			</div>
			<div class="table">
				<div class="tr">
          <div class="th thl">个人信息类型</div>
          <div class="th thr">个人信息字段</div>
				</div>
        <div class="tr">
          <div class="td tl">个人基本信息</div>
          <div class="td trr">手机号码、姓名、身份证号码、身份证正反面照片</div>
        </div>
        <div class="tr">
          <div class="td tl">企业基本信息</div>
          <div class="td trr">
            （1）公司法定代表人姓名、公司法定代表人手机号码、公司法定代表人身份证号码、公司法定代表人身份证正反面照片、法人授权委托书<br>
            （2）营业执照照片、企业名称、统一社会信用代码、注册资本（万元）、成立日期、营业期限、企业注册地址、企业归属省市<br>
            （3）开户许可证、开户行、 开户行账号、预留手机号
          </div>
        </div>
        <div class="tr">
          <div class="td tl">财产信息</div>
          <div class="td trr">对公账户基本信息（开户行名称、开户账号、预留手机号）、钱包余额、充值记录、支出记录</div>
        </div>
        <div class="tr">
          <div class="td tl">发货信息</div>
          <div class="td trr">承运车辆的规格、货物装卸地址、装卸货时间、发货人姓名/手机号、收货人姓名/手机号信息、运费金额、回单信息（回单类型、签收人姓名、地址、联系方式）、备注信息等与货物运输的必要信息</div>
        </div>
        <div class="tr">
          <div class="td tl">订单信息</div>
          <div class="td trr">承运车辆的规格、货物装卸地址、装卸货时间、发货人姓名/手机号、收货人姓名/手机号信息、运费金额、回单信息（回单类型、签收人姓名、地址、联系方式）、订单号、订单金额</div>
        </div>
        <div class="tr">
          <div class="td tl">地址信息</div>
          <div class="td trr">联系人姓名、联系方式、详细地址、地址简称、经纬度信息</div>
        </div>
        <div class="tr">
          <div class="td tl">个人位置</div>
          <div class="td trr">经纬度信息、地址</div>
        </div>
        <div class="tr">
          <div class="td tl">网络身份标识信息</div>
          <div class="td trr">SSID、BSSID、IP地址</div>
        </div>
        <div class="tr">
          <div class="td tl">设备信息</div>
          <div class="td trr">硬件型号、操作系统版本、设备配置、MAC/AndroidID/IDFA/uuid(idfv)/OpenUDID/OAID/WidevineId/GUID/MEID/SIM卡信息、设备连接信息以及设备状态信息、网络身份标识信息、WiFi列表、SSID、BSSID、IP地址、硬件设备序列号</div>
        </div>
        <div class="tr">
          <div class="td tl">操作日志信息</div>
          <div class="td trr">调试信息、所留存的访问日期与时间、搜索记录与内容、浏览记录与内容、使用记录、点击记录、IP地址信息</div>
        </div>
			</div>
      <div class="inline big">
				1.2 个人信息处理者：
			</div>
      <div class="inline normal">
				是指在个人信息处理活动中自主决定处理目的、处理方式的组织、个人。<br>
			</div>
      <div class="inline big">
				1.3 处理：
			</div>
      <div class="inline normal">
				包括对个人信息的收集、存储、使用、加工、传输、提供、公开和删除等。有关我们如何收集和使用您的个人信息，您可查看“2.我们如何收集和使用您的个人信息”。<br>
			</div>
      <div class="inline big">
				{{space}}1.3.1 收集：
			</div>
      <div class="inline normal">
				是指获得个人信息的控制权，可以自主决定对个人信息的处理目的、处理方式的行为，包括由个人信息主体主动向我们提供、通过我们与个人信息主体交互或记录个人信息主体行为等
			</div>
      <div class="inline big">
				“自动采集”
			</div>
      <div class="inline normal">
				方式，以及我们通过接收其他个人信息和/或搜集公开信息等
			</div>
      <div class="inline big">
				“间接获取”
			</div>
      <div class="inline normal">
				方式。<br>
			</div>
      <div class="inline big">
				{{space}}1.3.2 使用：
			</div>
      <div class="inline normal">
				我们会在
			</div>
      <div class="inline big">
				“2.1 个人信息的收集和使用”所列的表格中说明我们会将您的个人信息用于何种场景和目的，并列明相应的合法处理理由以供您了解我们需要遵循的相应义务。
			</div>
      <div class="inline normal">
				当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意，或告知您其他合法处理理由。本政策所述
			</div>
      <div class="inline big">
				“使用”
			</div>
      <div class="inline normal">
				专指我们对数据进行加工处理以实现数据的存储、访问和展示、汇聚融合、统计分析、个性化展示和自动决策等使用和利用方式。<br>
			</div>
      <div class="inline big">
				{{space}}您同意
			</div>
      <div class="inline normal">
				您同意我们将通过我们自身或受托方技术对您在使用顺丰产品或服务的过程中主动或被动、直接或间接提供的个人信息进行
			</div>
      <div class="inline big">
				汇聚融合、识别分析、数据画像或进一步加工，
			</div>
      <div class="inline normal">
				并形成多种类及不同颗粒度的能够反映您的行为习惯、兴趣爱好或者经济、健康、信用状况、身份特征的标签信息（以下简称
			</div>
      <div class="inline big">
				“标签信息”
			</div>
      <div class="inline normal">
				），我们会将标签信息用于具体的场景和目的中，以改进我们的服务，或向您展示和推荐更符合您的潜在需求的产品、服务或向您推广商业广告，包括：<br>
			</div>
      <div class="inline big">
				a） 自动化决策：
			</div>
      <div class="inline normal">
				是指利用个人信息对个人的行为习惯、兴趣爱好或者经济、健康、信用状况等，通过计算机系统和算法程序自动分析、评估并进行决策，一般而言，我们会将自动化决策用于如下场景：<br>
			</div>
      <div class="inline normal">
				{{space}}i） 我们将利用自动化决策机制评估您的设备手机号码的安全性，从而可能需要您进行其他核验方式登录。该决策决定可能显著影响您的合法权益（即能否使用我们的服务），您有权通过本政策所述的联系方式要求我们做出说明，并有权拒绝我们仅通过自动化决策的方式作出决定，我们将提供适当的救济方式。具体请见“4.5 约束信息系统自动决策”的描述。<br>
			</div>
      <div class="inline normal">
				{{space}}ii） 基于我们账户管理系统的统一性，通过某个产品收集的个人信息将有可能被汇总并在其他顺陆产品和服务中用于个性化展示目的。<br>
			</div>
      <div class="inline normal">
				{{space}}iii） 您可以通过顺陆货主小程序>右上角“...”中的设置中关闭相关功能，当您关闭个性化推荐设置时，顺陆将不再为您提供个性化的推荐服务。<br>
			</div>
      <div class="inline big">
				{{space}}b） 运营方经营保障：
			</div>
      <div class="inline normal">
				运营和向您提供服务是我们的重要经营活动。基于正常业务经营所需，我们需要对您的个人信息进行内部利用，包括开展内部审计、数据分析、进一步实践研究或学术研究，以及会将所收集到的信息用于大数据分析。例如，我们将收集到的信息用于分析形成不包含任何个人信息的统计类产品，展示顺陆服务的整体全貌，分析不同群体的行为模式等。我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的大数据分析信息。同时，我们需要使用收集的信息来提供顺陆的产品和服务、改进产品和服务的性能以及进行必要的业务运营与评估、客户支持等。基于保障业务安全运营及网络安全所需，我们需要收集您的
			</div>
      <div class="inline big">
				IP地址、设备信息、网络信息和操作日志，
			</div>
      <div class="inline normal">
				若您拒绝提供此类信息，则我们将无法向您确保本服务的正常运营。<br>
			</div>
      <div class="inline normal">
				{{space}}1.3.3 
			</div>
      <div class="inline big">
				保存：
			</div>
      <div class="inline normal">
				指将个人信息以电子或非电子形式记录于我们可访问和检索的介质中的行为。出于正常业务所需，我们会将产品所需个人信息根据不同的合法处理理由所需的保存期限内进行保存：<br>
			</div>
      <div class="inline normal">
				{{space}}a） 基于您的授权同意处理的个人信息将自收集之日起保存至处理目的实现、用户注销/删除账户全部信息或撤回同意且约定的反悔期届满；<br>
			</div>
      <div class="inline normal">
				{{space}}b） 基于订立或履行您作为一方当事人的合同所必需的个人信息将自收集之日起保存至合同履行完毕且诉讼时效届满；<br>
			</div>
      <div class="inline normal">
				{{space}}c） 基于履行法定义务所必需的个人信息将自收集之日起保存至法定义务履行完毕且诉讼时效届满。<br>
			</div>
      <div class="inline normal">
				{{space}}法律法规、规范性文件及监管规定对上述保存期限存在不同要求的，遵守法律法规、规范性文件及监管规定的要求。此外，我们对基于产品所收集的您的个人信息，原则上将依照最新法律要求保留在
			</div>
      <div class="inline big">
				中华人民共和国境内服务器。
			</div>
      <div class="inline normal">
				未满足法律法规、规范性文件及监管规定的条件和程序的，我们不会向境外主体提供您的任何个人信息。<br>
			</div>
      <div class="inline normal">
				{{space}}1.3.4
			</div>
      <div class="inline big">
				对外提供：
			</div>
      <div class="inline normal">
				指个人信息处理者向其他另一个人信息处理者提供个人信息，且接收方在个人信息主体被告知的个人信息的类别、处理目的和处理方式下处理个人信息的活动。<br>
			</div>
      <div class="inline normal">
				{{space}}1.3.5
			</div>
      <div class="inline big">
				委托处理：
			</div>
      <div class="inline normal">
				指个人信息处理者委托受托人处理个人信息，并对受托人的个人信息处理活动进行监督的活动。受托人仅能在受托范围内处理个人信息，未经个人信息处理者同意，受托人不得转委托他人处理个人信息。<br>
			</div>
      <div class="inline normal">
				{{space}}1.3.6
			</div>
      <div class="inline big">
				匿名化：
			</div>
      <div class="inline normal">
				是指个人信息经过处理无法识别特定自然人且不能复原的过程。<br>
			</div>
      <div class="inline normal">
				{{space}}1.3.7
			</div>
      <div class="inline big">
				关联方：
			</div>
      <div class="inline normal">
				指深圳市丰驰顺行信息技术有限公司直接或者间接控制的实体，或与深圳市丰驰顺行信息技术有限公司处于共同控制之下的任何公司或法人实体。本定义中的“实体”包括但不限于个人、合伙、公司及其他法律实体。其中目前已设立的关联公司有
			</div>
      <div class="inline big">
				浙江丰驰网络科技有限公司、天津市元合利科技有限公司、江西顺丰智达网络科技有限公司。<br>
			</div>
      <div class="inline big">
				2. 我们如何收集和使用您的个人信息<br>
			</div>
      <div class="inline big">
				{{space}}我们会遵循合法、正当、必要的原则，出于向您提供相关产品和服务的目的向您收集和处理您的个人信息，并以列表形式向您披露（请见下文示例），我们尽可能全面、完整、及时地向您披露您的个人信息的收集和使用情况，若您发现我们的披露存在错误或遗漏，请通过本政策所述的联系方式与我们联系。<br>
			</div>
      <div class="inline normal">
				2.1
			</div>
      <div class="inline big">
				个人信息的收集和使用<br>
			</div>
      <div class="inline big">
				{{space}}随着产品或服务的迭代、拓展、升级，我们收集和使用的您的个人信息类型将会发生变化，若发生上述情形，我们将通过更新本政策和顺丰产品中弹窗、页面等方式向您详细说明，并征求您的同意。本服务中，我们基于不同的处理目的所需要收集、处理的个人信息类别如下所列：
			</div>
      <div class="table">
        <div class="top">2.2如何使用个人信息</div>
				<div class="tr">
          <div class="th thl">功能点</div>
          <div class="th thr">个人信息使用</div>
				</div>
        <div class="tr">
          <div class="td tl">登录注册</div>
          <div class="td trr">创建账户需要获取手机号码、验证码；或微信手机号码授权，否则无法注册或登录顺丰运力货主小程序</div>
        </div>
        <div class="tr">
          <div class="td tl">个人实名认证</div>
          <div class="td trr">需要获取手机号码、姓名、身份证号码、身份证照片，来认证身份真实性</div>
        </div>
        <div class="tr">
          <div class="td tl">企业认证</div>
          <div class="td trr">提供个人信息收集中的企业基本信息，对信用及偿付能力进行基本的审核。</div>
        </div>
        <div class="tr">
          <div class="td tl">电子签约功能</div>
          <div class="td trr">根据个人信息收集中的企业基本信息，报送给电子签约平台用于电子签名认证以合同的签署</div>
        </div>
        <div class="tr">
          <div class="td tl">发货</div>
          <div class="td trr">基于物流信息交互及运输交易需要将1.1中发货信息提供给平台其他用户</div>
        </div>
        <div class="tr">
          <div class="td tl">支付功能</div>
          <div class="td trr">财产信息、订单信息；依据以上信息完成订单的支付</div>
        </div>
        <div class="tr">
          <div class="td tl">订单的查询</div>
          <div class="td trr">订单信息</div>
        </div>
        <div class="tr">
          <div class="td tl">订单消息的推送</div>
          <div class="td trr">个人基本信息、订单信息、设备信息</div>
        </div>
        <div class="tr">
          <div class="td tl">钱包</div>
          <div class="td trr">财产信息</div>
        </div>
        <div class="tr">
          <div class="td tl">地址管理</div>
          <div class="td trr">地址信息</div>
        </div>
        <div class="tr">
          <div class="td tl" style="border-right:1px solid #000000;">保障服务正常运行及交易安全所必须的功能</div>
          <div class="td trr" style="border-left:none;">网络身份标识信息、设备信息、操作日志信息</div>
        </div>
        <div class="tr">
          <div class="td tl">客服处理</div>
          <div class="td trr">个人信息、网络身份标识信息、订单信息、财产信息</div>
        </div>
			</div>
      <div class="inline big">
				2.2 设备权限信息的收集和使用<br>
			</div>
      <div class="inline big">
				{{space}}出于遵守法律法规、规范性文件、监管规定及保障交易安全的需要，以及为实现收集个人信息之目的，我们需要针对您所选择的不同业务功能，申请您向我们开启相应的设备访问权限。在您的手机系统允许的情况下，我们会在需要开启权限时向您弹窗说明用途并征得您的同意，您开启这些权限即代表您授权我们可以收集和处理这些信息来实现相应功能。您可以通过设备的相关设置取消授权，但取消后我们将无法为您提供相应的业务功能。此类需要开启的权限及其具体使用场景包括：<br>
			</div>
      <div class="inline big">
				{{space}}2.2.1位置信息<br>
			</div>
      <div class="inline big">
				{{space}}您开启终端设备及其他GPS设备、定位功能以及使用顺丰运力货主小程序基于位置提供相关服务时，收集您的位置信息：<br>
			</div>
      <div class="inline big">
				{{space}}a.通过GPS/WiFi方式收集您的地理位置信息；<br>
			</div>
      <div class="inline big">
				{{space}}b.当您在发货页面填写收发货地址时，根据定位信息默认选择定位城市以及定位附近的地点信息；<br>
			</div>
      <div class="inline big">
				{{space}}c.当您在新增地址时，根据定位信息默认选择定位城市以及定位附近的地点信息。<br>
			</div>
      <div class="inline big">
				{{space}}2.2.2 基于摄像头（相机）的附加功能<br>
			</div>
      <div class="inline big">
				{{space}}进行个人实名和企业认证时、会获取身份证件正反面、营业执照、法定代表人身份证正反面、开户许可证、法人授权委托函。<br>
			</div>
      <div class="inline big">
				{{space}}2.2.3 存储权限<br>
			</div>
      <div class="inline big">
				{{space}}开启我们可读取/写入您设备存储的权限后，您可以从前端操作上传移动终端设备存储空间内读取图片、文件、崩溃日志等必要信息，图片用于个人认证、企业认证提供凭证材料，崩溃日志信息帮助核查异常问题。<br>
			</div>
      <div class="inline big">
				{{space}}2.2.4 Photos照片权限<br>
			</div>
      <div class="inline big">
				{{space}}我们向您申请获取相册权限，图片用于个人实名、企业认证提供凭证材料。<br>
			</div>
      <div class="inline normal">
				2.3 我们如何使用cookie和同类技术<br>
			</div>
      <div class="inline normal">
				{{space}}2.3.1 Cookies和同类技术的使用<br>
			</div>
      <div class="inline normal">
				{{space}}为实现您联机体验的个性化需求，使您获得更轻松的访问体验，我们会在您的计算机或移动设备上发送一个或多个名为Cookies的小数据文件或同类技术文件，指定给您的Cookies是唯一的，它只能被将Cookies发布给您的域中的Web服务器读取。我们向您发送Cookies是为了简化您重复登录的步骤、帮助判断您的登录状态以及账户或数据安全。<br>
			</div>
      <div class="inline normal">
				{{space}}我们不会将Cookies用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookies、清除计算机上保存的所有 Cookies。大部分网络浏览器会自动接受Cookies，但您通常可根据自己的需要来修改浏览器的设置以拒绝Cookies。另外，您也可以清除软件内保存的所有Cookies，但如果您这么做，您可能需要在每一次访问时亲自更改用户设置，而且之前所记录的您的相应信息也均会被删除，并且可能会对您所使用的服务的安全性有一定影响。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。<br>
			</div>
      <div class="inline normal">
				2.4 在顺丰集团内使用您的个人信息<br>
			</div>
      <div class="inline normal">
				{{space}}2.4.1
			</div>
      <div class="inline big">
				我们将根据顺丰集团统一的信息安全管理要求和运营管控策略，在顺丰集团范围内汇聚融合并共同使用您在本政策“2.1 个人信息的收集和使用”所列的表格中的全部信息。
			</div>
      <div class="inline normal">
				若我们的提供范围或接收方的使用目的超越本政策的描述，则改变目的的接收方应重新获取您的同意。您有权通过本政策所述的联系方式向
			</div>
      <div class="inline big">
			  我们
			</div>
      <div class="inline normal">
				或
			</div>
      <div class="inline big">
				面向您收集和处理了您的个人信息的任一关联方
			</div>
      <div class="inline normal">
				提出申诉，或就本条描述的集团数据共享问题要求我们或面向您收集和处理了您的个人信息的任一关联方做出解释和回应。<br>
			</div>
      <div class="inline normal">
				{{space}}2.4.2
			</div>
      <div class="inline big">
				您的个人信息可能基于以下处理目的而在顺丰集团范围内共享提供并共同使用：<br>
			</div>
      <div class="inline big">
				 a）创建统一登录帐号，在集团范围内核验您的身份，统一身份认证并享受对应权益。<br>
			</div>
      <div class="inline big">
				 b）与关联方联合向您提供服务或共同实现具体产品的业务功能。<br>
			</div>
      <div class="inline big">
				 c）防范安全风险，在集团范围内对您的个人信息、标签信息等进行综合判断，检测及防范安全风险（例如钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等），更准确地识别违反法律法规或产品服务相关协议规则的情况，以保护您、其他用户、我们或关联公司的合法权益。<br>
			</div>
      <div class="inline big">
				 d）识别分析并在集团范围内加工形成标签信息，并用于集团内各关联方的自动化决策、个性化展示、运营保障、学术研究、通知和推送（包括向您发送商业广告和信息推送）及改进产品和服务。<br>
			</div>
      <div class="inline big">
				 e）法律法规、规范性文件及监管规定允许的以及您授权同意的其他用途。<br>
			</div>
      <div class="inline normal">
				{{space}}2.4.3
			</div>
      <div class="inline big">
				我们将通过制度、协议和技术手段控制顺丰集团内部数据流动的安全性。同时，为确保顺丰集团内部数据流动的安全性，我们将实施内部常规检查措施，并要求顺丰集团内各关联方严格执行集团信息安全管理要求和运营管控策略。<br>
			</div>
      <div class="inline normal">
				{{space}}2.4.4
			</div>
      <div class="inline big">
				顺丰集团：
			</div>
      <div class="inline normal">
				为避免歧义，仅就本政策而言，顺丰集团包括顺丰控股股份有限公司及其子公司、及与顺丰控股股份有限公司被共同控制之下的实体。<br>
			</div>
      <div class="inline normal">
				2.5 向第三方提供<br>
			</div>
      <div class="inline normal">
				{{space}}2.5.1
			</div>
      <div class="inline big">
				非经法律法规、规范性文件及监管规定许可或具备其他合法处理理由，我们不会向第三方提供您的个人信息。我们仅会出于合法、正当、必要、特定、明确的目的向第三方个人信息处理者提供您的个人信息。我们会与接收方依法签署相关保密协议，要求他们按照本政策的要求以及其他必要的保密和安全措施来处理个人信息。<br>
			</div>
      <div class="inline normal">
				{{space}}2.5.2
			</div>
      <div class="inline big">
				当您访问第三方网站、应用程序、产品和服务链接时，我们将根据您的明确授权向第三方提供您的个人信息，您应注意另行同意其为您提供的隐私政策或个人信息保护条款，您应尤为注意该等第三方网站、应用中独立接入的SDK由该接入方及SDK提供方向您共同承担责任。
			</div>
      <div class="inline normal">
				我们与该等第三方网站、应用程序、产品和服务提供者在法律规定和双方约定的范围内各自向您承担独立的个人信息保护责任。<br>
			</div>
      <div class="inline normal">
				2.6 转让<br>
			</div>
      <div class="inline big">
				{{space}}我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：<br>
			</div>
      <div class="inline normal">
				{{space}}2.6.1 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；<br>
			</div>
      <div class="inline normal">
				{{space}}2.6.2 在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。<br>
			</div>
      <div class="inline normal">
				{{space}}2.6.3 符合与您签署的相关协议（包括在线签署的电子协议）或其他的法律文件约定所提供；<br>
			</div>
      <div class="inline normal">
				{{space}}2.6.4 根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供。<br>
			</div>
      <div class="inline normal">
				2.7 公开披露<br>
			</div>
      <div class="inline big">
				{{space}}我们仅会在以下情况，公开披露您的个人信息：<br>
			</div>
      <div class="inline normal">
				{{space}}2.7.1 获得您单独同意后；<br>
			</div>
      <div class="inline normal">
				{{space}}2.7.2 基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。<br>
			</div>
      <div class="inline big">
				3. 我们如何保护您的个人信息<br>
			</div>
      <div class="inline normal">
				3.1 我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、使用、修改、公开披露、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办数据安全和隐私保护培训课程，加强员工对于个人信息保护重要性的认识。<br>
			</div>
      <div class="inline normal">
				3.2 我们的数据安全能力：顺丰成立了信息安全部门为顺丰的产品构建完整先进的数据安全保护体系，包括对用户信息进行分类分级、加密存储、数据访问权限控制；制定了内部数据管理制度和操作规程，从数据的收集、使用、删除或匿名化都有严格的流程要求，避免用户隐私数据被非法使用；确定接触用户个人信息的各部门及其负责人安全管理责任；建立用户个人信息收集、使用及其相关活动的工作流程和安全管理制度； 对工作人员及代理人实行权限管理，对批量查询、修改、复制、导出、删除个人信息实行审查，并采取防泄密措施；妥善保管记录用户个人信息的纸介质、光介质、电磁介质等载体，并采取相应的安全储存措施；对储存用户个人信息的信息系统实行接入审查，并采取入侵防范、病毒防护等措施；记录对用户个人信息进行操作的人员、时间、地点、事项等信息；定期举办数据安全和隐私保护培训，提高员工的个人信息保护意识。<br>
			</div>
      <div class="inline normal">
				3.3 我们会采取一切合理可行的措施，确保不会收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。<br>
			</div>
      <div class="inline normal">
				3.4 互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，从而导致您的合法权益受损，我们将承担相应的法律责任。<br>
			</div>
      <div class="inline normal">
				3.5 在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议以及对您的补救措施等。我们会及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。<br>
			</div>
      <div class="inline big">
				{{space}}同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。<br>
			</div>
      <div class="inline big">
				{{space}}若您发现您的个人信息泄露时，请您立即通过本政策所述的联系方式与我们联系，以便我们及时采取相应措施。<br>
			</div>
      <div class="inline big">
				4. 您的权利<br>
			</div>
      <div class="inline big">
				{{space}}按照中国相关的法律、法规、标准的通行做法，我们将努力保障您在我们的个人信息处理活动中享有的权利，包括但不限于：<br>
			</div>
      <div class="inline normal">
				4.1 查阅、复制和转移您的个人信息<br>
			</div>
      <div class="inline normal">
				{{space}}4.1.1 您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：<br>
			</div>
      <div class="inline big">
				{{space}}个人信息：
			</div>
      <div class="inline normal">
				如果您希望访问您的个人资料信息，您可以登陆顺陆货主小程序>我的查看您的个人信息，企业信息。<br>
			</div>
      <div class="inline normal">
				{{space}}账户信息：您可以登陆顺陆货主小程序>我的>我的钱包查看账户的余额信息、银行卡信息以及充值和支出记录。<br>
			</div>
      <div class="inline normal">
				{{space}}合同信息：您可以登陆顺陆货主小程序>我的>我的合同看您所有在顺陆签署的电子签章合同类信息<br>
			</div>
      <div class="inline normal">
				{{space}}订单信息：您可以登陆顺陆货主小程序>订单列表中查看您所有的发货订单及其完成情况<br>
			</div>
      <div class="inline normal">
				{{space}}回单信息：您可以登陆顺陆货主小程序>我的>回单管理中查看您所有需要司机上传的回单凭证<br>
			</div>
      <div class="inline big">
				{{space}}地址管理：
			</div>
      <div class="inline normal">
				您可以登陆顺陆货主小程序>我的>地址管理中查看您的常用地址、回单地址（可新建、修改、删除您的常用地址和回单地址）；<br>
			</div>
      <div class="inline normal">
				{{space}}4.1.2 您有权通过您的顺陆货主版帐号和密码登录您所注册的顺陆货主小程序自行查阅、复制、转移您的相关个人信息，法律法规规定的例外情况除外。在技术可行的情况下，我们将为您提供自行导出相关个人信息的功能，请注意，受限于当前的法律法规要求和/或我们的技术能力，某些个人信息无法自行导出，具体可导出个人信息请以导出界面的提示为准。<br>
			</div>
      <div class="inline normal">
				{{space}}4.1.3 如果您无法通过上述路径查阅个人信息，或若您需要复制或转移这些个人信息的，您可以随时通过本政策所述的联系方式与我们联系，我们将在十五个工作日内回复您的查阅、复制和转移请求，并在转移条件满足国家网信部门规定的条件时提供相应的转移途径。<br>
			</div>
      <div class="inline normal">
				4.2 更正和补充您的个人信息<br>
			</div>
      <div class="inline normal">
				{{space}}4.2.1 当您发现您的个人信息不准确或者不完整的，您有权按照本政策第4.1条所提示的路径进行更正和补充。<br>
			</div>
      <div class="inline normal">
				{{space}}4.2.2 如您需要更正您在使用我们的产品或服务过程中产生的其他个人信息，如修改订单的始发目的地址或运费金额信息，您可以通过顺陆货主小程序>我的>客服中心直接拨打客服电话。<br>
			</div>
      <div class="inline normal">
				{{space}}4.2.3 如果您无法通过上述路径更正和补充这些个人信息，您可以随时通过本政策所述的联系方式与我们联系，我们将在十五个工作日内回复您的请求。<br>
			</div>
      <div class="inline normal">
				4.3 删除您的个人信息<br>
			</div>
      <div class="inline normal">
				{{space}}4.3.1 您可以通过本政策第4.1条所提示的路径删除您注册后主动提交的个人信息。<br>
			</div>
      <div class="inline normal">
				{{space}}4.3.2 在以下情形中，若我们未主动删除您的个人信息的，您可以通过本政策所述的联系方式向我们提出删除个人信息的请求：<br>
			</div>
      <div class="inline normal">
				{{space}}a)处理目的已实现、无法实现或者为实现处理目的不再必要；<br>
			</div>
      <div class="inline normal">
				{{space}}b)我们停止提供产品或者服务，或者保存期限已届满；<br>
			</div>
      <div class="inline normal">
				{{space}}c)您撤回了您的同意；<br>
			</div>
      <div class="inline normal">
				{{space}}d)我们违反法律、行政法规或者违反约定处理您的个人信息；<br>
			</div>
      <div class="inline normal">
				{{space}}e)法律、行政法规规定的其他情形。<br>
			</div>
      <div class="inline normal">
				{{space}}4.3.3 我们将在收到您的删除个人信息申请后十五个工作日内回复。若我们决定响应您的删除请求，我们还将同时通知从我们处获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。<br>
			</div>
      <div class="inline normal">
				{{space}}4.3.4 当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。<br>
			</div>
      <div class="inline normal">
				{{space}}4.3.5 法律、行政法规规定的保存期限未届满，或者删除个人信息从技术上难以实现的，我们将停止除存储和采取必要的安全保护措施之外的处理。<br>
			</div>
      <div class="inline normal">
				4.4 改变您授权同意的范围<br>
			</div>
      <div class="inline normal">
				{{space}}4.4.1 顺陆货主小程序发货时，需要用到位置信息的获取以及订阅消息通知的授权，您可以通过顺陆货主小程序右上角“...”设置中撤回您对小程序的授权。<br>
			</div>
      <div class="inline normal">
				{{space}}4.4.2 除此之外，您可以根据“4.1查阅、复制和转移您的个人信息”提示的路径等方式给予或撤回您的授权同意或可以通过更改智能设备中的蓝牙、定位、语音设置等访问权限或具体产品的设置选项。<br>
			</div>
      <div class="inline normal">
				{{space}}4.4.3 如果您有其他撤回同意的要求无法实现，您可以通过本政策所述的联系方式向我们发送通知改变授权同意的范围。<br>
			</div>
      <div class="inline normal">
				{{space}}4.4.4 当您撤回同意后，我们将不再处理相应的个人信息。但您撤回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。<br>
			</div>
      <div class="inline normal">
				{{space}}4.4.5 特别地，如果您不想接受我们给您发送的订单消息变更通知，您可通过顺陆货主小程序右上角“...”设置中关闭消息订阅通知的授权。<br>
			</div>
      <div class="inline normal">
				4.5 约束信息系统自动决策<br>
			</div>
      <div class="inline normal">
				{{space}}4.5.1 在某些业务功能中，例如登录环境检测功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。该决策决定可能显著影响您的合法权益，您有权通过本政策所述的联系方式要求我们做出说明，并有权拒绝我们仅通过自动化决策的方式作出决定，我们将提供适当的救济方式保障您的合法权利，例如向您说明自动化的决策逻辑及对您产生的相关影响，或引入人工审核复核自动化决策结果的正确性。<br>
			</div>
      <div class="inline normal">
				4.6 响应您的上述请求<br>
			</div>
      <div class="inline normal">
				{{space}}4.6.1 为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。<br>
			</div>
      <div class="inline normal">
				{{space}}4.6.2 您的请求我们将在十五个工作日内做出答复。如您对我们的答复不满意，还可以通过本政策所述的联系方式向我们投诉。<br>
			</div>
      <div class="inline normal">
				{{space}}4.6.3 对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。<br>
			</div>
      <div class="inline normal">
				{{space}}4.6.4 在以下情形中，按照法律法规要求，我们将无法响应您的请求：<br>
			</div>
      <div class="inline normal">
				{{space}}a)与个人信息处理者履行法律法规规定的义务相关的；<br>
			</div>
      <div class="inline normal">
				{{space}}b)与国家安全、国防安全直接相关的；<br>
			</div>
      <div class="inline normal">
				{{space}}c)与公共安全、公共卫生、重大公共利益直接相关的<br>
			</div>
      <div class="inline normal">
				{{space}}d)与刑事侦查、起诉、审判和执行判决等直接相关的；<br>
			</div>
      <div class="inline normal">
				{{space}}e)个人信息处理者有充分证据表明个人信息主体存在主观恶意或滥用权利的；<br>
			</div>
      <div class="inline normal">
				{{space}}f)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br>
			</div>
      <div class="inline normal">
				{{space}}g)响应您的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；<br>
			</div>
      <div class="inline normal">
				{{space}}h)涉及商业秘密的。<br>
			</div>
      <div class="inline normal">
				5. 我们如何处理儿童的个人信息<br>
			</div>
      <div class="inline normal">
				5.1 当您在非登录状态下浏览我们的产品时，我们仅会收集有关您在使用具体产品过程中的个人当前设备状态信息及必要的个人常用设备信息，且
			</div>
      <div class="inline big">
				受现有技术限制，我们无法判断您是否为未满14周岁的儿童，但我们会严格按照您的授权同意范围使用该等信息，并按照本政策的承诺对您的个人信息予以保护。<br>
			</div>
      <div class="inline normal">
				5.2 在您注册登录账户并填写年龄相关信息或进行实名验证时，我们会收集到您的年龄信息并可识别您是否为儿童。鉴于我们的产品主要面向成年人用户使用，
			</div>
      <div class="inline big">
				如果您未满14周岁且未经父母或监护人的同意，您不应创建自己的个人账户或使用我们的服务。对于经父母或监护人同意而收集的未满14周岁的未成年人的个人信息的情况，我们仅会在受到相关法律法规允许、父母或监护人明确同意或保护未成年人所必要的情况下使用或公开披露此信息。
			</div>
      <div class="inline normal">
				敬请查阅我们制定的专门规则
			</div>
      <div @click="toNextPage" class="inline normal mark">
				《儿童个人信息保护规则》
			</div>
      <div class="inline normal">
				。<br>
			</div>
      <div class="inline normal">
				5.3 如果我们发现自己在未获得可证实的父母或监护人同意的情况下，收集了未满14周岁的未成年人的个人信息，则会设法尽快删除相关数据。<br>
			</div>
      <div class="inline normal">
				5.4 特别说明：用户如需使用顺陆货主小程序需完成个人实名认证、企业实名认证以及合同的签署。<br>
			</div>
      <div class="inline big">
				6. 我们对去世用户的个人信息保护<br>
			</div>
      <div class="inline normal">
				6.1 用户（仅限自然人）去世后，其近亲属为了自身的合法、正当利益，可以通过本政策所述的联系方式对去世用户的相关个人信息行使查阅、复制、更正、删除等权利，但是去世用户生前另有安排的除外。<br>
			</div>
      <div class="inline normal">
				6.2 您理解并确认，为了充分保护去世用户的个人信息权益，申请行使本条权利的去世用户近亲属需要根据顺丰的指定流程或客服提示，提交去世用户的身份证明文件、死亡证明文件、申请人的身份证明文件、申请人与去世用户的亲属关系证明文件，并提供申请行使的权利种类及目的。您可以拨打客服联系方式4001116663或通过本政策所述的联系方式进一步获取更多关于去世用户的个人信息保护流程、条件等事项。<br>
			</div>
      <div class="inline big">
				7. 您的个人信息如何在全球范围内转移<br>
			</div>
      <div class="inline normal">
				7.1 原则上，我们在中华人民共和国境内收集和产生的个人信息，将根据适用法律的要求存储在境内。<br>
			</div>
      <div class="inline normal">
				7.2 我们仅会出于履行与您的合同所必需的目的或其他合法处理理由向境外提供您的个人信息，并承诺将具备现行法律法规要求的条件。<br>
			</div>
      <div class="inline normal">
				7.3 若根据适用法律，我们需要同时遵守其他国家或地区的数据保护法保护您的个人信息的，则我们也将进行相应的合规保障和调整。<br>
			</div>
      <div class="inline big">
				8. 我们如何更新隐私政策及法律适用<br>
			</div>
      <div class="inline normal">
				8.1 我们的隐私政策可能变更。
			</div>
      <div class="inline big">
				未经您明确同意，我们不会削减您按照本政策所应享有的权利。
			</div>
      <div class="inline normal">
				我们会发布对本政策的更新版本。<br>
			</div>
      <div class="inline normal">
				8.2 对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明本政策的具体变更内容）。<br>
			</div>
      <div class="inline normal">
				8.3 本政策的重大变更包括但不限于：<br>
			</div>
      <div class="inline normal">
				{{space}}8.3.1 我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；<br>
			</div>
      <div class="inline normal">
				{{space}}8.3.2 我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；<br>
			</div>
      <div class="inline normal">
				{{space}}8.3.3 个人信息对外提供、转让或公开披露的主要对象发生变化；<br>
			</div>
      <div class="inline normal">
				{{space}}8.3.4 您参与个人信息处理方面的权利及其行使方式发生重大变化；<br>
			</div>
      <div class="inline normal">
				{{space}}8.3.5 我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；<br>
			</div>
      <div class="inline normal">
				{{space}}8.3.6 个人信息安全影响评估报告表明存在高风险时。<br>
			</div>
      <div class="inline normal">
				8.4 我们还会将本政策的旧版本存档，供您查阅。<br>
			</div>
      <div class="inline normal">
				8.5 本政策仅适用于我们的发件人位于中国境内的客户，如您想了解我们业务所及的其他国家/地区的隐私政策，请查阅本政策第7.3条中的相关隐私保护文件。<br>
			</div>
      <div class="inline normal">
				8.6
			</div>
      <div class="inline big">
				本政策以的订立、执行、解释及争议的解决均适用中华人民共和国法律（不包括港、澳、台），排除适用冲突规则。<br>
			</div>
      <div class="inline big">
				9. 如何联系我们<br>
			</div>
      <div class="inline normal">
				9.1 如果您有任何疑问、意见或建议，可以通过以下方式联系我们的产品团队或我们专门负责个人信息保护的部门，一般情况下，我们将在十五个工作日内回复。<br>
			</div>
      <div class="inline normal">
				{{space}}公司名称：深圳市丰驰顺行信息技术有限公司<br>
			</div>
      <div class="inline normal">
				{{space}}注册地址：深圳市南山区粤海街道滨海社区高新南十道81号、83号、85号软件产业基地1栋B1202<br>
			</div>
      <div class="inline normal">
				{{space}}常用办公地址：
			</div>
      <div class="inline big">
				广东省深圳市南山区高新南区科苑南路3176号彩讯科创中心17楼<br>
			</div>
      <div class="inline normal">
				{{space}}4001116663<br>
			</div>
      <div class="inline normal">
				{{space}}产品团队联系方式：sfyl_it@sfmail.sf-express.com<br>
			</div>
      <div class="inline normal">
				{{space}}个人信息保护负责部门联系方式：DPO@sfmail.sf-express.com<br>
			</div>
      <div class="inline normal">
				9.2 如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，且与我们协商无法达成一致的，您还可以向深圳市丰驰顺行信息技术有限公司所在地有管辖权的法院提起诉讼来寻求解决方案。<br>
			</div>
		</div>
	</div>
</div>
</template>

<script>
export default {
  data() {
    return {
      space: "  "
    }
  },
  created() {},
  mounted() {},
  methods: {
    checkHistory() {
      this.$emit('lookHistory')
    },
    toNextPage() {
      this.$emit('lookChildrenRule')
    }
  }
}
</script>
<style lang="less" scoped>
.wraper{
  width: 100%;
  height: 100%;
  padding: 46px 37px;
  box-sizing: border-box;
  font-size: 14px;
  color: #252945;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 400;
  color: #000000;
  word-break: break-all;
  .mark{
    color:#DC1E32;
    cursor: pointer;
  }
  .history_info{
    .btext{
      font-size: 14px;
    }
    .check_history_btn{
      color:#DC1E32;
      margin: 12px 0;
      cursor: pointer;
    }
  }
  .text_info{
    .inline{
      display: inline;
    }
    .big{
      font-weight: 600;
    }
    .table{
      margin: 16px 0;
      .top{
        display: flex;
        height: 50px;
        justify-content: start;
        align-items: center;
        font-weight: 600;
        border-top: 1px solid #000000;
        border-left: 1px solid #000000;
        border-right: 1px solid #000000;
      }
      .tr{
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #000000;
        border-left: 1px solid #000000;
        border-right: 1px solid #000000;
      }
      .th{
        font-weight: 600;
        border-top: 1px solid #000000;
      }
      .thl{
        flex:1;
        border-right: 1px solid #000000;
      }
      .thr{
        flex:2;
      }
      .td{
        height: 100%;
        
      }
      .tl{
        flex: 1;
      }
      .trr{
        flex: 2;
        border-left: 1px solid #000000;
      }
    }
  }
}
</style>